import React from "react";
import "~/css/LayoutSettings.css";
import "~/css/RadioButton.css";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { isProcessingAtom, layoutSelectAtom, volumeAtom } from "~/Atom";
import { PlaySound } from "~/SoundUtils";

const layoutSettings: React.FC = () => {
  const { t } = useTranslation();
  const [isProcessing] = useAtom(isProcessingAtom);
  const [layoutSelect, setLayoutSelect] = useAtom(layoutSelectAtom);
  const [volume] = useAtom(volumeAtom);

  const handleLayoutSelectChange = (mode: number) => {
    PlaySound("push2", volume);
    setLayoutSelect(mode);
  };

  return (
    <>
      <div className="layout-selector">
        <div className="title font-default-normal-20">{t("layoutSelect")}</div>
        <div className="layout-container">
          <form className="layout-list">
            <div className="radio-row">
              <label className="custom-radio-label">
                <input
                  className="custom-radio"
                  type="radio"
                  value="0"
                  checked={layoutSelect === 0}
                  name="layoutMode"
                  id="0"
                  onChange={() => handleLayoutSelectChange(0)}
                  disabled={isProcessing}
                />
                <span className="radio-custom-circle"></span>
                <span className="view-text font-default-normal-20">{t("layoutDefault")}</span>
              </label>
              <label className="custom-radio-label">
                <input
                  className="custom-radio"
                  type="radio"
                  value="1"
                  checked={layoutSelect === 1}
                  name="layoutMode"
                  id="1"
                  onChange={() => handleLayoutSelectChange(1)}
                  disabled={isProcessing}
                />
                <span className="radio-custom-circle"></span>
                <span className="view-text font-default-normal-20">{t("layout1")}</span>
              </label>
              <label className="custom-radio-label">
                <input
                  className="custom-radio"
                  type="radio"
                  value="2"
                  checked={layoutSelect === 2}
                  name="layoutMode"
                  id="2"
                  onChange={() => handleLayoutSelectChange(2)}
                  disabled={isProcessing}
                />
                <span className="radio-custom-circle"></span>
                <span className="view-text font-default-normal-20">{t("layout2")}</span>
              </label>
              <label className="custom-radio-label">
                <input
                  className="custom-radio"
                  type="radio"
                  value="3"
                  checked={layoutSelect === 3}
                  name="layoutMode"
                  id="3"
                  onChange={() => handleLayoutSelectChange(3)}
                  disabled={isProcessing}
                />
                <span className="radio-custom-circle"></span>
                <span className="view-text font-default-normal-20">{t("layout3")}</span>
              </label>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default layoutSettings;
